import store from "@/store";
export const carOption = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  dialogType: 'drawer',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      search: true,
      searchMultiple: true,
      searchClearable: true,
      hide: true,
      type: 'select',
      display: false,
      dicData: store.getters.porductTypes,
      searchOrder: 999,
    },
    {
      label: '租赁人',
      search: true,
      prop: 'name',
      display: true,
      hide: true,
      searchOrder: 998,
    },
    {
      label: '车库位置',
      prop: 'carManagePositionId',
      search: true,
      searchOrder: 995,
      hide: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      type: 'select',
      dicData: [],
      props: {
        label: 'carPosition',
        value: 'id',
      },
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      search: true,
      searchOrder: 994,
    },
    // {
    //   label: '进件编号',
    //   prop: 'businessCode',
    //   search: false,
    //   display: true,
    // },
    {
      label: '所属代理商',
      prop: 'busssinessDeptName',
      search: false,
      type: 'select',
      display: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '产品类型',
      prop: 'rentType',
      search: false,
      type: 'select',
      display: false,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租赁人',
      search: false,
      prop: 'tenantName',
      display: true,
      hide: false,
    },
    // {
    //   label: '车牌号',
    //   prop: 'carFirstNumber',
    //   isFieldShow:[0,1] //  待售车辆 和 已售车辆 展示
    // },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      search: true,
      searchOrder: 996,
      isFieldShow:[0,1] //  待售车辆 和 已售车辆 展示
    },
    {
      label: '租赁金额',
      prop: 'tenantAmount',
    },
    {
      label: '车库位置',
      prop: 'carPosition',
    },
    {
      label: '来源',
      prop: 'source',
      search: true,
      type: 'select',
      searchOrder: 997,
      dicData:[
        {
          label:'租后',
          value:1
        },
        {
          label:'法务',
          value:2
        },
      ]
    },
    {
      label: '状态',
      prop: 'stateStr',
      isFieldShow:[2] //  全部 type 展示
    },
    {
      label: '入库日期',
      prop: 'createTime',
      isFieldShow:[0,2]  // 全部 & 待售车辆 type 展示
    },
    {
      label: '滞留时间',
      prop: 'retentionTime',
      isFieldShow:[0,2]  // 全部 & 待售车辆 type 展示
    },
    {
      label: '卖车日期',
      prop: 'sellCarTime',
      isFieldShow:[1]  // 已售车辆 type 展示
    },
    {
      label: '卖车时长',
      prop: 'sellCarTimeLength',
      isFieldShow:[1]  // 已售车辆 type 展示
    },
    // {
    //   label: '起租日',
    //   prop: 'commencementDate',
    //   searchRange: true,
    //   type: 'daterange',
    //   format: 'yyyy-MM-dd',
    //   valueFormat: 'yyyy-MM-dd',
    //   searchOrder: 995,
    //   search: true,
    //   hide: true,
    // },
  ],
};
